import { rotate } from '@/_utils/math'
import { prettyPin } from '@/_utils/pretty-pin'

export default function OutdoorOverlay(vm, google, map, options = {}) {
  const buildingMouseClass = 'building-mouse-target'

  gm.prototype = new google.maps.OverlayView()

  function gm(vm, map, options) {
    this.vm = vm
    this.map = map
    this.divs = []
    this.observer = null
    this.prettyPin = null

    this.setMap(map)
  }

  function floorUniqueKey(floor, key) {
    return 'floorMapContainer' + floor._id + key
  }

  gm.prototype.onAdd = function() {
    // Watch changes and make pretty pins
    prettyPin(this, `${this.vm.keyComponent || ''}outdoor`)
    if (!this.vm.buildings?.length) {
      return
    }
    const vm = this.vm
    for (const building of this.vm.buildings) {
      const divBuilding = document.createElement('div')
      divBuilding.classList.add('outdoor-building')
      divBuilding.style.borderStyle = 'none'
      divBuilding.style.borderWidth = '0px'
      divBuilding.style.position = 'absolute'
      divBuilding.title = building.building_name

      for (const floor of building.floors) {
        // Draw each floor
        const div = document.createElement('div')
        div.setAttribute('data-building-name', building.building_name)
        div.setAttribute('data-floor-id', floor._id)
        div.setAttribute('data-floor-name', floor.name)
        div.setAttribute('data-numof-floors', building.floors.length)

        const imgId = vm.floorImgId(floor)

        div.classList.add('outdoor-building--floor')
        div.classList.add(floorUniqueKey(floor, vm.keyComponent || ''))
        div.style.transform = 'rotate(' + floor.floor_angle + 'deg)'

        let imgUrl = floor.floor_file
        if (!imgUrl) {
          div.classList.add('outdoor-building--floor--no-img')
          imgUrl = '/blank.png'
        }

        const img = document.createElement('img')
        img.src = imgUrl
        img.id = imgId
        img.style.width = '100%'
        img.style.height = '100%'
        img.style.opacity = floor.floor_opacity / 100
        div.appendChild(img)

        divBuilding.appendChild(div)
      }

      this.divs.push(divBuilding)

      const panes = this.getPanes()
      // We have 2 layer
      // 1. overlayMouseTarget layer -> User can click
      // 2. overlayLayer layer -> User could not click
      // So we need clone 1 building to 2 object.
      const divBuildingBehind = divBuilding.cloneNode(true)

      divBuilding.classList.add(buildingMouseClass)
      const imgs = divBuilding.getElementsByTagName('img')
      if (imgs.length) {
        for (let img of imgs) {
          img.remove()
        }
      }

      panes.overlayMouseTarget.appendChild(divBuilding)
      panes.overlayLayer.appendChild(divBuildingBehind)
    }
  }

  gm.prototype.draw = function() {
    const overlayProjection = this.getProjection()

    for (const floor of this.vm.floors) {
      const divs = document.getElementsByClassName(floorUniqueKey(floor, this.vm.keyComponent || ''))
      if (!divs) {
        continue
      }

      for (const div of divs) {
        const bounds = new google.maps.LatLngBounds(
          new google.maps.LatLng(floor.floor_sw_lat, floor.floor_sw_lon),
          new google.maps.LatLng(floor.floor_ne_lat, floor.floor_ne_lon)
        )

        const sw = overlayProjection.fromLatLngToDivPixel(bounds.getSouthWest())
        const ne = overlayProjection.fromLatLngToDivPixel(bounds.getNorthEast())

        const numofFloor = div.getAttribute('data-numof-floors')
        const isCurrentBuilding =
          !this.vm.selectedFloor.building_name || this.vm.selectedFloor.building_name !== floor.building_name

        div.style.left = sw.x + 'px'
        div.style.top = ne.y + 'px'
        div.style.width = ne.x - sw.x + 'px'
        div.style.height = sw.y - ne.y + 'px'

        // Set position of control button
        if (div.parentNode.classList.contains(buildingMouseClass)) {
          const a_right = floor.floor_ne_lat
          const a_top = floor.floor_ne_lon
          const a_center_x = (floor.floor_sw_lat + floor.floor_ne_lat) / 2
          const a_center_y = (floor.floor_sw_lon + floor.floor_ne_lon) / 2

          const a_right_top = overlayProjection.fromLatLngToDivPixel(new google.maps.LatLng(a_right, a_top))
          const a_center_xy = overlayProjection.fromLatLngToDivPixel(new google.maps.LatLng(a_center_x, a_center_y))

          const newPos = rotate(a_right_top.x, a_right_top.y, a_center_xy.x, a_center_xy.y, floor.floor_angle)

          div.style.left = newPos[0] + 'px'
          div.style.top = newPos[1] + 'px'
          div.style.width = 0
          div.style.height = 0

          if (numofFloor > 1) {
            const controlId = 'control' + floor._id

            let span = document.getElementById(controlId)
            if (!span) {
              span = document.createElement('span')
              span.id = controlId
              span.classList.add('outdoor-building--floor--control')
              span.addEventListener('click', (e) => {
                e.stopPropagation()
                vm.handleShowFloorSelectModal(floor.building_name)
              })

              div.appendChild(span)
            }

            let controlText = floor.name
            if (isCurrentBuilding || vm.isViewAllFloor) {
              controlText = this.vm.$t('all')
            }

            span.innerText = controlText
          }
        }

        if (numofFloor > 1) {
          div.classList.remove('is-frame-only', 'is-hidden', 'is-selected-floor')
          if (isCurrentBuilding || this.vm.isViewAllFloor) {
            div.classList.add('is-frame-only')
          } else if (this.vm.selectedFloor._id !== floor._id) {
            div.classList.add('is-hidden')
          } else {
            div.classList.add('is-selected-floor')
          }
        }
      }
    }
  }

  gm.prototype.onRemove = function() {
    for (let div of this.divs) {
      div.parentNode.removeChild(div)
      div = null
    }
    this.divs = []
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  return new gm(vm, map, options)
}
